import axios from "axios";
import { refreshUserToken } from "./auth";
import { updateIsLoggedIn } from "../redux/slices/user";
import { store } from "../redux/store";
import { fetchSessionToken } from "../utils/shopifyAppBridge";
import { domain } from "./constants";

const { dispatch } = store;

// Set base URL (optional but useful)
axios.defaults.baseURL = domain;

// REQUEST INTERCEPTOR
axios.interceptors.request.use(
  async function (config) {
    // const shopifyHost = new URLSearchParams(window.location.search).get('host');

    // if (shopifyHost) {
    //   // Embedded Shopify app - use session token
    //   // alert("qqqqqqqqqq")
    //   const sessionToken = await fetchSessionToken();
    //   // alert("dddd")
    //   if (sessionToken) {
    //     config.headers.Authorization = `Bearer ${sessionToken}`;
    //   }
    // } else {
    //   // Normal login user
    //   // alert("aaaaaaa")
    //   const access = localStorage.getItem("access");
    //   if (access) {
    //     config.headers.Authorization = `Bearer ${access}`;
    //   }
    // }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      originalRequest.url.includes("account/login/refresh")
    ) {
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      dispatch(updateIsLoggedIn(false));
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const credentials = { refresh: localStorage.getItem("refresh") };

      return new Promise((resolve, reject) => {
        refreshUserToken(credentials, (err, res) => {
          if (res !== null) {
            localStorage.setItem("access", res.access);
            originalRequest.headers.Authorization = `Bearer ${res.access}`;
            resolve(axios(originalRequest)); // retry original request
          } else {
            reject(error);
          }
        });
      });
    }

    return Promise.reject(error);
  }
);
